export const checkForAppUpdates = async () => {
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    const sw = registrations.find(
      (reg) => reg.active && reg.active.scriptURL.includes("service-worker.js")
    );
    if (sw) {
      sw.update();
    }
  } catch (error) {
    console.error("Error checking for app updates", error);
    //Ignore error
  }
};
